import { ObservableQuery } from '@apollo/client';
import { Project } from '@ih/app/shared/apis/interfaces';

export class FindAllProjectsSuccess {
  public static readonly type =
    '[Organisation/Projects/List] FindAllProjectsSuccess';
  constructor(
    public readonly result: ObservableQuery.Result<{
      findAllProjects: Project[];
    }>,
  ) {}
}
